require('./profilePictureEditor.scss');
require('./profilePictureEditor.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { EditAlias } = require('commonsComponents/editAlias');
const { OKButton } = require('components/commons/OKButton/OKButton');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const Avatar = require('components/avatar/avatar');
const AvatarPicker = require('components/avatarPicker/avatarPicker');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { PROC_CHANGE_PICTURE, PROC_CANCEL, PROC_END, recordProcess } = require('utilities/tagging');


class ProfilePictureEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedImageUrl: this.getCurrentAvatar(),
        };
        this.handleAvatarChange = this.handleAvatarChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    getAvatar(value) {
        return this.getAvatars().find(obj => obj.get('value') === value.value).get('url');
    }

    getAvatars() {
        return this.props.fields.get('listAvatars');
    }

    getCurrentAvatar() {
        return this.props.fields.get('avatar');
    }

    getSelectedAvatar() {
        return (typeof this.state.value === 'string') ? this.state.value : null;
    }

    getSelectedImageUrl(value) {
        return this.getAvatar(value);
    }

    getUsername() {
        const immFields = this.props.fields;
        const username = `${immFields.get('nombreCliente')} ${immFields
            .get('apellidoUno')
            .get('apellido')} ${immFields.get('apellidoDos').get('apellido')}`;

        return username;
    }

    buildEditor() {
        const { fields, setProfileAvatarEditorError } = this.props;
        const profileImgDescription = formatText('imgDescription-profile');
        const avatars = this.getAvatars().toJS();
        const selectedAvatar = this.getSelectedAvatar();
        const currentlyVisibleImage = this.getCurrentAvatar();
        const username = this.getUsername();
        const selectedImageUrl = this.state.selectedImageUrl || this.getCurrentAvatar();
        const profileAvatarEditModalOpen = fields.get('profileAvatarEditModalOpen');
        const profileAvatarEditError = fields.get('profileAvatarEditError');

        return (
            <form className="row" onSubmit={this.handleSubmit}>
                <div className="col-xs-3">
                    <Avatar
                        imgDescription={profileImgDescription}
                        imgType="edit-mode"
                        imgUrl={selectedImageUrl}
                        id={'avatar-preview'}
                    />
                </div>
                <div className="col-xs-9">
                    <h2 className="profile-picture-editor__header">
                        {username}
                    </h2>
                    <AvatarPicker
                        avatars={avatars}
                        defaultValue={currentlyVisibleImage}
                        onAvatarChange={this.handleAvatarChange}
                        onChangeModal={this.props.onChangeModal}
                        openModal={profileAvatarEditModalOpen}
                        selectedAvatar={selectedAvatar}
                        setProfileAvatarEditorError={setProfileAvatarEditorError}
                    />
                </div>
                <div className="col-xs-12">
                    <div className="profile-picture-editor__buttons">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleCancel}
                            className="pull-left"
                        >
                            {formatText('profile-profileCancelButtonLabel')}
                        </OKButton>
                        <div className="profile-picture-editor__buttons__wrapper-button-right">
                            <OKButton typeButton="submit" disabled={profileAvatarEditError}>
                                {formatText('profile-profileSaveButtonLabel')}
                            </OKButton>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

    handleAvatarChange(value) {
        const { setProfileAvatarEditorError } = this.props;
        let newState = {};
        newState.drawUrl = '';

        if (value.drawUrl) {
            newState.drawUrl = value.drawUrl;
            newState.selectedImageUrl = value.drawUrl;
            newState.isAvatar = true;
        } else if (value.imgUrl) {
            newState.selectedImageUrl = value.imgUrl;
            newState.value = value.file;
            newState.isAvatar = false;
        } else {
            const img = document.getElementById(value.id);
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            newState.selectedImageUrl = canvas.toDataURL();
            newState.isAvatar = false;
            newState.value = canvas.toDataURL();
        }

        setProfileAvatarEditorError(false);
        this.setState(newState);
    }

    handleCancel() {
        const { onClick, setProfileAvatarEditorError } = this.props;

        recordProcess(PROC_CHANGE_PICTURE, PROC_CANCEL);
        this.setState({ selectedImageUrl: this.getCurrentAvatar() });
        setProfileAvatarEditorError(false);
        onClick();
    }

    handleSubmit(evt) {
        const { value, selectedImageUrl, isAvatar, drawUrl } = this.state;

        evt.preventDefault();
        recordProcess(PROC_CHANGE_PICTURE, PROC_END);

        if (drawUrl) {
            this.props.handleSubmit(drawUrl, selectedImageUrl, false);
        } else {
            this.props.handleSubmit(value, selectedImageUrl, isAvatar);
        }
    }

    buildColectiveLabel() {
        return (
            <div className="row">
                <div className="col-xs-12 text-left">
                    <div className="profile-picture-editor__alias-colective-label2">
                        <FormattedText value="profile-profileColectiveLabel" />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { editable, fields, onAliasChange, onClick } = this.props;
        const currentlyVisibleImage = this.getCurrentAvatar();
        const profileImgDescription = formatText('imgDescription-profile');
        const username = this.getUsername();
        const alias = fields.get('alias');
        const isCollectiveUser = fields.get('isCollective');
        const treatment = fields.get('tratamiento');

        let content = (
            <div className="row">
                <div className="col-xs-3">
                    <Avatar
                        imgType="view-mode"
                        imgUrl={currentlyVisibleImage}
                        imgDescription={profileImgDescription}
                        id={'avatar-editor'}
                    />
                    <div className="profile-picture-editor__button-container">
                        <WebappRender>
                            <OKButton modifier="task" onClick={onClick}>
                                <i className="icon-editar profile-picture-editor__icon" />
                            </OKButton>
                        </WebappRender>
                    </div>
                </div>
                <div className="col-xs-9">
                    <h2 className="profile-picture-editor__header">
                        {`${treatment} ${username}`}
                    </h2>
                    <div>
                        <FormattedText
                            className="profile-picture-editor__alias-label"
                            value="profile-profileAliasLabel"
                        />
                        <WebappRender>
                            <span className="profile-picture-editor__alias-edit">
                                <EditAlias
                                    alias={alias}
                                    fontSize="16px Outfit Regular"
                                    isEmptyAllowed={true}
                                    postAlias={onAliasChange}
                                />
                            </span>
                        </WebappRender>
                    </div>
                    <ContactCenterRender>
                        {isCollectiveUser && this.buildColectiveLabel()}
                    </ContactCenterRender>
                </div>
            </div>
        );

        if (editable) {
            content = this.buildEditor();
        }

        return (
            <OKSectionBox className="profile-picture-editor">
                {content}
            </OKSectionBox>
        );
    }
}

ProfilePictureEditor.propTypes = {
    AvatarPicker: PropTypes.object,
    children: PropTypes.any,
    editable: PropTypes.bool.isRequired,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onAliasChange: PropTypes.func.isRequired,
    onChangeModal: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    selectedAvatar: PropTypes.string,
    setProfileAvatarEditorError: PropTypes.func
};

module.exports = ProfilePictureEditor;
